// Bandeau permanent pendant la periode de grace.
//
// Complement de PaymentGraceModal : la modale se ferme, le bandeau reste. Il
// n'apparait QUE pendant la grace ; une fois la retrogradation actee, c'est la
// modale de reactivation qui porte le message, et un bandeau permanent de plus
// releverait du harcelement.

import { AlertTriangle } from "lucide-react";
import { Link as WaspRouterLink, routes } from "wasp/client/router";
import useTranslation from "../client/hooks/useTranslation";
import { usePaymentGrace } from "./usePaymentGrace";

export default function PaymentGraceBanner() {
  const t = useTranslation();
  const grace = usePaymentGrace();

  if (!grace.isInGrace) return null;

  const isLastDay = grace.daysRemaining <= 1;
  const text = isLastDay
    ? t.paymentGrace.bannerTextLastDay
    : t.paymentGrace.bannerText.replace("{days}", String(grace.daysRemaining));

  return (
    <div
      role="alert"
      className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 border-b border-amber-500/30 bg-amber-500/10 px-4 py-2 text-center text-sm text-amber-700 dark:text-amber-300"
    >
      <span className="flex items-center gap-2">
        <AlertTriangle className="h-4 w-4 shrink-0" aria-hidden="true" />
        {text}
      </span>
      <WaspRouterLink
        to={routes.AccountRoute.to}
        className="font-semibold underline underline-offset-2 hover:no-underline"
      >
        {t.paymentGrace.bannerAction}
      </WaspRouterLink>
    </div>
  );
}
